export interface LiveFeedItem {
  time: string;
  message: string;
}

export interface ComparisonCard {
  id: string;
  variant: "traditional" | "generic" | "us";
  items: string[];
}

export interface TechFeature {
  id: string;
  icon: "llm" | "visual" | "delivery";
}

export interface StatItem {
  id: string;
  value: number;
  suffix: string;
  prefix?: string;
  decimals?: number;
  emoji: string;
}

export interface Testimonial {
  id: string;
  role: string;
  quote: string;
  rating: number;
  initials: string;
  color: string;
  avatar?: string;
}

export const liveFeedItems: LiveFeedItem[] = [
  { time: "3分鐘前", message: "旺角區時裝 IG Shop 購買了全套港式宣傳包" },
  { time: "12分鐘前", message: "銅鑼灣商戶加購了 AI 廣東話配音" },
  { time: "18分鐘前", message: "觀塘網店老闆購買 WhatsApp 自動化行銷劇本" },
  { time: "25分鐘前", message: "中環精品店訂購 IG Feed 10 幅圖套餐" },
  { time: "31分鐘前", message: "深水埗凍肉電商購買全套宣傳包" },
  { time: "44分鐘前", message: "荃灣美容店加購 AI 廣東話 Copy 50 條" },
  { time: "52分鐘前", message: "元朗手作店購買港風視覺排版引擎" },
  { time: "1小時前", message: "尖沙咀餐廳訂購 TikTok 剪片自動化包" },
  { time: "1小時前", message: "沙田寵物店購買 IG Story 動態模板" },
  { time: "2小時前", message: "灣仔咖啡店加購 AI 廣東話配音" },
];

export const comparisonCards: ComparisonCard[] = [
  {
    id: "traditional",
    variant: "traditional",
    items: [
      "comparison_traditional_1",
      "comparison_traditional_2",
      "comparison_traditional_3",
      "comparison_traditional_4",
    ],
  },
  {
    id: "generic",
    variant: "generic",
    items: [
      "comparison_generic_1",
      "comparison_generic_2",
      "comparison_generic_3",
      "comparison_generic_4",
    ],
  },
  {
    id: "us",
    variant: "us",
    items: [
      "comparison_us_1",
      "comparison_us_2",
      "comparison_us_3",
      "comparison_us_4",
    ],
  },
];

export const techFeatures: TechFeature[] = [
  { id: "1", icon: "llm" },
  { id: "2", icon: "visual" },
  { id: "3", icon: "delivery" },
];

export const statItems: StatItem[] = [
  {
    id: "1",
    value: 320,
    suffix: "+",
    emoji: "🚀",
  },
  {
    id: "2",
    value: 8500,
    suffix: "+",
    emoji: "📝",
  },
  {
    id: "3",
    value: 680,
    suffix: "K+",
    prefix: "HKD ",
    decimals: 0,
    emoji: "💰",
  },
  {
    id: "4",
    value: 99.8,
    suffix: "%",
    decimals: 1,
    emoji: "⚡",
  },
];

export const testimonials: Testimonial[] = [
  {
    id: "1",
    role: "時裝 IG Shop 老闆娘",
    quote:
      "以前每晚收舖重要執圖寫 Caption 到兩點，個人殘晒。依家用 $1,050 買全套宣傳包，30秒出齊 10 幅圖同文案，仲要係好正宗嘅廣東話，即刻有時間瞓覺！",
    rating: 5,
    initials: "IG",
    color: "#60EFFF",
    avatar: "/images/testimonials/testimonial-fashion.png",
  },
  {
    id: "2",
    role: "凍肉電商老闆",
    quote:
      "分拆買咗個 WhatsApp 自動化行銷劇本 ($880)，導入左之後，半夜自動幫我追返班漏咗張單嘅客，第二朝睇返多咗十幾張單，幾百蚊成本一晚就賺返！",
    rating: 5,
    initials: "凍",
    color: "#00FF87",
    avatar: "/images/testimonials/testimonial-meat.png",
  },
  {
    id: "3",
    role: "觀塘網店創辦人",
    quote:
      "試過好多 AI 工具，出嚟嘅嘢似翻譯機。港微創真係唔同，文案似旺角 sales 咁貼地，客人都問我邊度搵 copywriter。",
    rating: 5,
    initials: "網",
    color: "#A78BFA",
    avatar: "/images/testimonials/testimonial-online.png",
  },
  {
    id: "4",
    role: "中環精品店 Marketing",
    quote:
      "長假期照樣 30 秒出貨，唔使等 designer 返工。視覺排版自動 match 我哋 brand color，啲 IG post 靚到唔似 AI 做。",
    rating: 5,
    initials: "精",
    color: "#F472B6",
    avatar: "/images/testimonials/testimonial-boutique.png",
  },
];
